// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2HakG","head":"ProcedureTableInfo_head__1Gx4R"};